import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./outline/discover.svg";
var DiscoverOutline_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  DiscoverOutline_default as default
};
